export enum InventoryActionStatus{
    Pending = "Pending",
    Done = "Done",
    Cancelled = "Canceled"
  }